import React, { useState, useEffect } from "react";
import { useNavigate, suseLocation } from "react-router-dom";
import { DeleteIcon} from "../../../../assets/icons";
import { useAppContext } from "../../../Context/AppContext";
import CustomTooltip from "../../../CustomTooltip";
import FormField from "../../../FormField/FormField";
import "../RipianiSection.scss";

const headers = [
  { key: "nome", label: "Nome ripiano", width: "80%" },
  { key: "action", label: "", width: "5%" },
];

const RipianiTable = ({ ripiani, handleDeleteRipiano, handleUpdateRipiano, edit }) => {

  console.log("ripiani", ripiani);
  return (
    <>
      <div className="ripiani-table-container">
        <div className="">
          <header className="ripiani-table-header">
            {headers?.map((header, index) => (
              <div
                key={index}
                className="ripiani-header-item"
                style={{
                  maxWidth: `${header.width}`,
                  minWidth: `${header.width}`,
                }}
              >
                <div className="ripiani-header-item-text">
                  {header.label}
                </div>
              </div>
            ))}
          </header>
          {ripiani && ripiani.length > 0 ? (
            ripiani.map((item, index) => {
              return (
                <div className={`ripiani-row`} key={index}>
                  <input // value displayed in the form field
                    disabled={!edit}
                    className="input-value"
                    type="text"
                    value= { item.nome }
                    onChange={(e) => handleUpdateRipiano({ nome: e.target.value, id:  item.id})}
                  />
                  <button
                    className="ripiani-icons"
                    onClick={() => handleDeleteRipiano(item)}
                  >
                    <DeleteIcon fillColor="var(--archeo-color)" />
                      </button>
                </div>
              );
            })
          ) : (
            <div className="ripiani-row">
              <div className="ripiani-row-item" style={{ width: "100%" }}>
                Nessun dato presente
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RipianiTable;
